<template>
  <v-list-item>
    <v-list-item-action>
      <v-switch
        :input-value="value"
        :false-value="false"
        :true-value="true"
        v-bind="$attrs"
        v-on="$listeners"
        @change="$emit('input', $event)"
      />
    </v-list-item-action>

    <v-list-item-content>
      <v-list-item-title>{{ title }}</v-list-item-title>
      <v-list-item-subtitle v-if="description" class="text-wrap">
        {{ description }}
      </v-list-item-subtitle>
    </v-list-item-content>

    <v-list-item-action v-if="$slots['actions']">
      <v-menu bottom left :offset-y="!$vuetify.breakpoint.mobile">
        <template #activator="{ on, attrs }">
          <template v-if="$vuetify.breakpoint.mobile">
            <v-btn icon v-bind="attrs" v-on="on">
              <v-icon>$freshvue-administration-menu-mobile</v-icon>
            </v-btn>
          </template>
          <template v-else>
            <v-btn color="primary" depressed v-bind="attrs" v-on="on">
              {{ $t('misc.options') }}
              <v-icon right>$freshvue-administration-menu-desktop</v-icon>
            </v-btn>
          </template>
        </template>

        <slot name="actions" />
      </v-menu>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
export default {
  name: 'AdministrationSettingsSwitch',

  components: {},

  props: {
    value: {
      type: null,
      required: true
    },

    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: false,
      default: null
    }
  }
}
</script>
